import * as bs from 'bootstrap';

import { initDataModal } from './behaviours/DataModal';
import { initDataToast } from './behaviours/DataToast';
import { initCustomElements } from './behaviours/CustomElements';
import { initDataHref } from './behaviours/DataHref';
import { initDataPaste } from './behaviours/DataPaste';

export { bs };

initDataModal();
initDataToast();
initDataHref();
initCustomElements();
initDataPaste();
